namespace $ {
	/** @deprecated Use $mol_crypto2_hash */
	export let $mol_crypto_hash = $mol_crypto2_hash	
}
